<div class="form-group">
  <label for="prod-m">{{ 'form.attribute'| translate }}</label>
  <angular2-multiselect [data]="attributeList"
      [(ngModel)]="attributeSelected"
      [settings]="multiselectSettings[EMULTI_SELECT_SETTING.NO_SEARCH]"
      (onSelect)="onAttributeSelect()">
  </angular2-multiselect>
</div>
